import { render, staticRenderFns } from "./XDropdown.vue?vue&type=template&id=e0e89914"
import script from "./XDropdown.vue?vue&type=script&lang=js"
export * from "./XDropdown.vue?vue&type=script&lang=js"
import style0 from "./XDropdown.vue?vue&type=style&index=0&id=e0e89914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports